import React from 'react';
import { Grid } from '@elliemae/ds-basic/Grid';
import WarningTriangle from '@elliemae/ds-icons/WarningTriangle';
import { toMobile, __UNSAFE_FONT_TO_DIMSUM, __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import DSButton from '@elliemae/ds-basic/Button';
import styled from 'styled-components';

var EmptyStateWrapper = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "sc-1ddwbs7-0"
})(["min-width:132px;max-width:384px;height:fit-content;"]);
var Icon = /*#__PURE__*/styled(WarningTriangle).withConfig({
  componentId: "sc-1ddwbs7-1"
})(["fill:", ";color:", ";justify-self:center;"], function (props) {
  return props.theme.colors.neutral[300];
}, function (props) {
  return props.theme.colors.neutral[300];
});
var PrimaryMessage = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-1ddwbs7-2"
})(["text-align:center;font-weight:bold;font-size:", ";color:", ";margin-top:", ";margin-bottom:", ";"], function (props) {
  return toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(3)]);
}, function (props) {
  return props.theme.colors.neutral[600];
}, function (props) {
  return __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.s);
}, function (props) {
  return __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xs);
});
var SecondaryMessage = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-1ddwbs7-3"
})(["text-align:center;font-size:", ";color:", ";margin:0;"], function (props) {
  return toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(400)]);
}, function (props) {
  return props.theme.colors.neutral[500];
});
var Button = /*#__PURE__*/styled(DSButton).withConfig({
  componentId: "sc-1ddwbs7-4"
})(["margin-top:", ";justify-self:center;width:fit-content;"], function (props) {
  return __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.m);
});
var EmptyState = function EmptyState(_ref) {
  var _ref$primaryMessage = _ref.primaryMessage,
      primaryMessage = _ref$primaryMessage === void 0 ? 'No Results Found' : _ref$primaryMessage,
      secondaryMessage = _ref.secondaryMessage,
      buttonLabel = _ref.buttonLabel,
      _ref$onButtonClick = _ref.onButtonClick,
      onButtonClick = _ref$onButtonClick === void 0 ? function () {} : _ref$onButtonClick;
  return /*#__PURE__*/React.createElement(EmptyStateWrapper, null, /*#__PURE__*/React.createElement(Icon, {
    size: "xxl"
  }), primaryMessage && /*#__PURE__*/React.createElement(PrimaryMessage, null, primaryMessage), secondaryMessage && /*#__PURE__*/React.createElement(SecondaryMessage, null, secondaryMessage), buttonLabel && /*#__PURE__*/React.createElement(Button, {
    buttonType: "secondary",
    labelText: buttonLabel,
    onClick: onButtonClick
  }));
};

export { EmptyState };
//# sourceMappingURL=EmptyState.js.map
